import { useEffect } from 'react';
import { ButtonProps } from '../../core/button/button';
import { UploadButton } from '../../core/upload/upload-button/upload-button';
import { UseCreateMediaItemOpts } from '../hooks/useCreateMediaItem';
import { MediaBackendAdapter } from '../types';

export type CreateMediaItemButtonProps = Omit<ButtonProps, 'onClick'> &
  Pick<UseCreateMediaItemOpts, 'folderId' | 'onMediaItemCreated'> & {
    backendAdapter: MediaBackendAdapter;
    onMediaItemError?: (error: string) => void;
  };

export const CreateMediaItemButton = ({
  backendAdapter,
  folderId,
  onMediaItemCreated,
  onMediaItemError,
  children,
  ...buttonProps
}: CreateMediaItemButtonProps) => {
  const { createMediaItem, error, uploadProgress } = backendAdapter.useCreateMediaItem({
    folderId,
    onMediaItemCreated,
  });

  const onFileSelected = (image: File) => createMediaItem({ image });

  useEffect((): void => {
    if (error) {
      console.log(error);
      onMediaItemError?.(error);
    }
  }, [error, onMediaItemError]);

  return (
    <UploadButton onFileSelected={onFileSelected} accept="image/jpeg,image/png" {...buttonProps}>
      {children}
      {uploadProgress ? ` (${uploadProgress}%)` : ''}
    </UploadButton>
  );
};
